import type { TMMutationData } from '@tempus/trials-types';
import isNull from 'lodash/isNull';
import omitBy from 'lodash/omitBy';

import { SelectOption } from '~/store/trialSearch/state';

interface Mutation {
  gene: string;
  reported: boolean;
  pVarSingleChar?: string;
  cVar?: string;
  fusedGene?: string;
}
export interface BiomarkerSelectOption extends SelectOption {
  mutation: Mutation;
}

export type BiomarkerFilter = Pick<
  TMMutationData,
  'gene' | 'geneLabel' | 'pVarSingleChar' | 'cVar' | 'fusedGene' | 'fusedGeneLabel'
> & {
  display: string;
  weight: number;
};

export const formatBiomarkerOptions = (input: BiomarkerFilter[]): BiomarkerSelectOption[] =>
  input.map(({ display, gene, pVarSingleChar, cVar, fusedGene }) => ({
    label: display,
    value: display,
    mutation: omitBy(
      {
        gene,
        reported: true,
        pVarSingleChar,
        cVar,
        fusedGene,
      },
      isNull,
    ) as unknown as Mutation, // TypeScript unable to infer that gene & reported are not null
  }));
